import ModalElement from './ModalElement';
import CookieConsentModal from '../Components/CookieConsentModal';
class CookieConsentModalElement extends ModalElement {
    constructor() {
        super(...arguments);
        this.element = CookieConsentModal;
    }
}
export default CookieConsentModalElement;
